import { useEffect, useState } from "react";

const NAV = [
  { href: "#signals", label: "快速自检" },
  { href: "#compare", label: "官仿对照" },
  { href: "#steps", label: "五步辨真" },
  { href: "#tactics", label: "常见套路" },
  { href: "#checklist", label: "自查清单" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="wrap flex items-center justify-between gap-4 py-3">
        <a href="#top" className="group flex items-center gap-2.5" aria-label="回到顶部">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-shield-check-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg text-foreground-950">辨真 · 吃瓜官网识别</span>
            <span className="mt-1 text-[11px] text-foreground-600 tracking-wide">防伪辨别 · 避坑指南</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#checklist"
            className="ml-2 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始自查
            <i className="ri-arrow-right-line"></i>
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="wrap flex flex-col gap-1 py-3" aria-label="移动端主导航">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#checklist"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              开始自查
              <i className="ri-arrow-right-line"></i>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}